import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Translate } from "../../../../Enums/Tranlate";
import EmployeesService from "../../../../../services/HRM/EmployeesService";
import VacationsService from "../../../../../services/HRM/VacationsService";
import ScrollPagination from "../../../../common/ScrollPagination";

const AddVacationsModal = ({ modal, setModal, item, setShouldUpdate }) => {
	const [formData, setFormData] = useState({
		employee: "",
		departure_day: "",
		return_day: "",
		reason: "",
		type: "",
		// number_of_days: ""
	});
	const lang = useSelector((state) => state.auth.lang);
	const reasonsOptions = [
		{ label: Translate[lang].emergency_leave, value: "emergency_leave" },
		{ label: Translate[lang].annual_leave, value: "annual_leave" },
	];
	const typesOptions = [
		{ label: Translate[lang].paid, value: "paid" },
		{ label: Translate[lang].not_paid, value: "not_paid" },
	];
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const [maxDate, setMaxDate] = useState("");
	const vacationsService = new VacationsService();
	const employeesService = new EmployeesService();

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				employee: {
					label: item?.employee?.name,
					value: item?.employee?.id,
				},
				departure_day: item?.departureDay?.split("T")[0] || "",
				return_day: item?.returnDay?.split("T")[0] || "",
				reason: item?.reason
					? reasonsOptions.find(
							(type) => type.value === item.reason.toLocaleLowerCase(),
						)
					: "",
				type: item?.type
					? typesOptions.find(
							(type) => type.value === item.type.toLocaleLowerCase(),
						)
					: "",
			});
		}
	}, [item]);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			employeeId: formData?.employee?.value,
			departureDay: formData?.departure_day,
			returnDay: formData?.return_day,
			reason: formData?.reason?.value?.toLocaleUpperCase(),
			type: formData?.type?.value?.toLocaleUpperCase(),
		};
		// if(formData?.reason?.value === "emergency_leave") data["number_of_days"] = formData?.number_of_days

		if (isAdd) {
			vacationsService.create(data)?.then((res) => {
				if (res && res?.status === 201) {
					toast.success("Vacation Added Successfully");
					setShouldUpdate((prev) => !prev);
					setModal();
				}
			});
		} else {
			vacationsService.update(formData?.id, data)?.then((res) => {
				if (res && res?.status === 200) {
					toast.success("Vacation Updated Successfully");
					setShouldUpdate((prev) => !prev);
					setModal();
				}
			});
		}
	};

	useEffect(() => {
		if (!!formData?.departure_day) {
			const startDate = new Date(formData?.departure_day); // Set your start date here
			const calculatedMaxDate = new Date(startDate);
			calculatedMaxDate.setMonth(startDate.getMonth() + 6); // Add 6 months

			const formattedMaxDate = calculatedMaxDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
			setMaxDate(formattedMaxDate);
		}
	}, [formData?.departure_day]);

	return (
		<Modal
			className={lang === "en" ? "en fade addProduct" : "ar fade addProduct"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Header>
					<Modal.Title>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.vacation}
					</Modal.Title>
					<Button
						variant=""
						className="close"
						style={{
							right: lang === "en" ? "0" : "auto",
							left: lang === "ar" ? "0" : "auto",
						}}
						onClick={() => {
							setModal();
						}}>
						<span>&times;</span>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={6}>
							<label className="text-label">{Translate[lang].employee}</label>

							<ScrollPagination
								Service={employeesService}
								value={formData?.employee}
								nameVal="name"
								setData={(e) =>
									setFormData((prev) => ({ ...prev, employee: e }))
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.departure_day}
								type="date"
								placeholder={Translate[lang]?.departure_day}
								bsSize="lg"
								name="departure_day"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.departure_day}
								onChange={(e) =>
									setFormData({ ...formData, departure_day: e.target.value })
								}
							/>
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang]?.return_day}
								type="date"
								placeholder={Translate[lang]?.return_day}
								bsSize="lg"
								min={formData.departure_day}
								max={maxDate}
								name="return_day"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.return_day}
								onChange={(e) =>
									setFormData({ ...formData, return_day: e.target.value })
								}
							/>
						</Col>

						<Col md={6}>
							<label className="text-label">{Translate[lang].reason}</label>
							<Select
								placeholder={Translate[lang]?.select}
								options={reasonsOptions}
								value={formData.reason}
								onChange={(e) => setFormData({ ...formData, reason: e })}
							/>
						</Col>

						{/* {formData.reason?.value === "emergency_leave" && <Col md={6}>
                            <AvField
                                label={Translate[lang]?.number_of_days}
                                type='number'
                                min='0'
                                placeholder={Translate[lang]?.number_of_days}
                                bsSize="lg"
                                name='number_of_days'
                                // validate={{   (not req)
                                //     required: {
                                //         value: true,
                                //         errorMessage: Translate[lang].field_required
                                //     }
                                // }}
                                value={formData.number_of_days}
                                onChange={(e) => setFormData({...formData, number_of_days: e.target.value})}
                            />
                        </Col>} */}
						<Col md={6}>
							<label className="text-label">{Translate[lang].type}</label>
							<Select
								placeholder={Translate[lang]?.select}
								options={typesOptions}
								value={formData.type}
								onChange={(e) => setFormData({ ...formData, type: e })}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={setModal} variant="danger light">
						{Translate[lang]?.close}
					</Button>
					<Button variant="primary" type="submit" disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddVacationsModal;
